import pkg from '../package.json';

var module = {
  name: pkg.name,
  version: pkg.version,
  build: pkg.build,
  mode: 'prod',
};

if (process.env.NODE_ENV === 'development') {
  module.mode = 'dev';
}

// Evita que o Hub seja definido duas vezes
if (!Object.prototype.hasOwnProperty.call(window, 'MdHub')) {
  window.MdHub = {
    domain: 'local.memed.com.br', // Domínio do script plataforma.hub.js - Ex: 'local.memed.com.br'
    initialized: false, // O MdHub já foi inicializado?
    mode: 'server', // Variável que indica o modo no qual o MdHub está rodando.
    options: {},
    environments: undefined,
    onReady: undefined,
    // Testa se é possivel escrever no local storage
    hasStorage: function hasStorage() {
      try {
        window.localStorage.setItem('test', 'test');
        window.localStorage.removeItem('test');

        return true;
      } catch (exception) {
        return false;
      }
    },

    /**
     * Inicializa uma instancia do MdHub
     * @param  {Object} options Opções de inicialização
     */
    init: function init(options) {
      if (!this.initialized) {
        this.initialized = true;

        if (this.onReady) this.onReady();

        // Checa se o navegador atual somente envia postMessages com String
        MdHub.postMessage.checkSendAsString();

        if (options.apiKey) {
          if (Object.prototype.hasOwnProperty.call(window, 'module')) {
            // Mantido para retrocompatibilidade
            /* eslint-disable no-param-reassign */
            options.build = module.build;
            options.version = module.version;
          }
          this.getEnvironments('server');
          this.server.init(options);
        } else {
          this.getEnvironments('client');
          this.client.init(options);
        }
      }
    },

    /**
     * Retorna a última mensagem trafegada no módulo
     *
     * @return {Objec} Message Data
     */
    getLastMessage: function getLastMessage() {
      return this.postMessage.lastMessage;
    },

    getEnvironments: function getEnvironments(mode) {
      if (MdHub.environments !== undefined) return MdHub.environments;
      if (mode === 'server') {
        fetch("/modulos/platform.environments/envs.json", {method: 'GET',redirect: 'follow'})
          .then(response => response.json())
          .then(envs => MdHub.environments = envs)
          .catch(error => console.error('Ouve um erro ao recuperar as envs do ambinente', error));
      }
      else {
        if (mode === 'client' && window.MdHub) {
          MdHub.command.send('hub', 'core:getEnvironment', module.name).then(function getEnvironments(environments) { 
            MdHub.environments = environments;
          })
        }
      }
      return MdHub.environments;
    },
  };
}

window.MdHub.getEnvironments();
